import { useState, useEffect } from 'react';
import styles from './SchemaSelector.module.css';

const SchemaSelector = ({schemas, onSelect, onPreview, defaultValue})=>{
    const [selectedIndex, setSelectedIndex] = useState(() => {
        if(defaultValue && schemas && schemas.length > 0){
            const index = schemas.findIndex(s => s._id === defaultValue);
            return index >= 0 ? index : schemas.length - 1;
        }
        return schemas && schemas.length > 0 ? schemas.length - 1 : 0;
    });

    // Update selectedIndex when schemas or defaultValue changes
    useEffect(() => {
        if(schemas && schemas.length > 0){
            let newIndex;
            if(defaultValue){
                const index = schemas.findIndex(s => s._id === defaultValue);
                if(index >= 0){
                    newIndex = index;
                } else {
                    newIndex = schemas.length - 1;
                }
            } else {
                // If no defaultValue match, select the latest (last) schema
                newIndex = schemas.length - 1;
            }
            setSelectedIndex(newIndex);
            // Trigger preview for the selected schema
            if(onPreview && schemas[newIndex]){
                onPreview(schemas[newIndex]);
            }
        }
    }, [schemas, defaultValue, onPreview]);

    if(!schemas || schemas.length === 0){
        return (<><div className={styles.errorMessage}>No schemas available</div></>)
    }
    if(!onSelect){
        return (<><div className={styles.errorMessage}>SchemaSelector: missing required parameter `onSelect`</div></>)
    }

    const selectedSchema = schemas[selectedIndex];
    const schemaProperties = selectedSchema?.definition?.properties || {};

    const handleSelectChange = (ev) => {
        const newIndex = parseInt(ev.target.value);
        setSelectedIndex(newIndex);
        const newSchema = schemas[newIndex];
        if(onPreview && newSchema){
            onPreview(newSchema);
        }
    };

    const handleApply = () => {
        if(selectedSchema && onSelect){
            onSelect(selectedSchema);
        }
    };

    return (<>
        <div style={{marginBottom: '1em'}}>
            <label>Schema version:</label>
            <select value={selectedIndex} onChange={handleSelectChange}>
                {schemas.map((s, index)=>{
                    const short = s.contentHashShort || (s.contentHash ? String(s.contentHash).slice(-8) : null);
                    const label = short
                        ? `Version ${s.version} (…${short})`
                        : `Version ${s.version}`;
                    return <option value={index} key={s._id}>{label}</option>;
                })}
            </select>
        </div>
        
        {selectedSchema && schemaProperties && Object.keys(schemaProperties).length > 0 && (
            <div style={{
                padding: '1em',
                marginBottom: '1em',
                backgroundColor: '#f8f9fa',
                border: '1px solid #dee2e6',
                borderRadius: '4px'
            }}>
                <h4 style={{marginTop: 0, marginBottom: '0.75em'}}>Schema Preview</h4>
                <div style={{maxHeight: '300px', overflowY: 'auto'}}>
                    {Object.entries(schemaProperties).map(([key, val]) => (
                        <div key={key} style={{
                            padding: '0.5em',
                            marginBottom: '0.5em',
                            backgroundColor: '#fff',
                            border: '1px solid #e9ecef',
                            borderRadius: '3px'
                        }}>
                            <div style={{fontWeight: 'bold'}}>
                                {val.title || key}
                                {val.required && <span style={{color: '#dc3545', marginLeft: '0.25em'}}>*</span>}
                            </div>
                            <div style={{fontSize: '0.9em', color: '#6c757d'}}>
                                Type: {val.type || 'string'}
                                {val.description && <span> • {val.description}</span>}
                            </div>
                        </div>
                    ))}
                </div>
                <button 
                    type="button"
                    onClick={handleApply}
                    style={{
                        marginTop: '1em',
                        padding: '0.5em 1em',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '1em'
                    }}
                >
                    Apply Schema
                </button>
            </div>
        )}
    </>)
}

export default SchemaSelector;